var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgA2Pb(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h24v24H0z"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 11.5,
    height: 23,
    x: 0.5,
    y: 0.5,
    fill: "#F8F8F8",
    stroke: "#BBB",
    rx: 0.686
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#BBB",
    d: "M5 21h5v1H5z"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(-1 0 0 1 24 0)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 11.5,
    height: 23,
    x: 0.5,
    y: 0.5,
    fill: "#F8F8F8",
    stroke: "#BBB",
    rx: 0.686
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#BBB",
    d: "M5 21h5v1H5z"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgA2Pb);
export default __webpack_public_path__ + "static/media/A2PB.484a44f15c73a70e8734f27e4bb97a24.svg";
export { ForwardRef as ReactComponent };